import React, { useEffect } from 'react';

import { useHistory, useParams } from 'react-router';
import { getPath } from 'utils/router';
import { connect, useDispatch } from 'react-redux';

import { hideAllNotification } from 'store/alertes/alertesReducer';
import {
    API_GET_EMPLOYES_LISTE_METIER_ASSO,
    API_MODIFIER_EMPLOYE_METIER_ASSO,
    API_REINITIALISER_MOT_DE_PASSE_EMPLOYE,
    CONTEXT_GET_EMPLOYES_LISTE,
    CONTEXT_MODIFIER_EMPLOYE,
    CONTEXT_REINITIALISER_MOT_DE_PASSE_EMPLOYE,
} from 'constants/apiUrls.constants';
import PropTypes from 'prop-types';
import usagerClientReducer from 'store/usagerReducer';
import { Button, ButtonGroup, ButtonLink, Col, Row, SegmentLoader } from '@si-armes/dsfr-react';
import { Link } from 'react-router-dom';
import { FormProvider, useForm } from 'react-hook-form';
import { getAPI, postAPI, putAPI, reinitialiseAPI } from 'store/apiReducer';
import RoutesMonCompte from '../routes';
import RoutesListeEmployes from '../liste-employes/routes';
import EmployeForm from '../ajouter-employe/EmployeForm';

const ModifierEmploye = ({
    dataEmploye,
    isLoadingEmploye,
    isLoadingModifierEmploye,
    isLoadingReinitialiserMotDePasse,
    dataModifierEmploye,
    clearAlertes,
}) => {
    const history = useHistory();
    const { id } = useParams();
    const dispatch = useDispatch();
    const hookForm = useForm({
        mode: 'onChange',
    });

    const {
        formState: { errors },
        reset,
        handleSubmit,
    } = hookForm;

    const disableButton = () => {
        return !!(errors && (errors.nom || errors.prenomUn || errors.email));
    };

    const onSubmit = async (data) => {
        dispatch(
            putAPI(
                usagerClientReducer,
                `${API_MODIFIER_EMPLOYE_METIER_ASSO}/${id}`,
                data,
                CONTEXT_MODIFIER_EMPLOYE,
            ),
        );
    };

    const handleReinitialiserMotDePasse = async () => {
        dispatch(
            putAPI(
                usagerClientReducer,
                API_REINITIALISER_MOT_DE_PASSE_EMPLOYE.replace('{id}', id),
                {},
                CONTEXT_REINITIALISER_MOT_DE_PASSE_EMPLOYE,
            ),
        );
    };

    useEffect(() => {
        if (dataModifierEmploye) {
            const handleRedirect = async () => {
                await dispatch(reinitialiseAPI(CONTEXT_MODIFIER_EMPLOYE));

                history.push(getPath(RoutesListeEmployes));
            };

            handleRedirect();
        }
    }, [dataModifierEmploye]);

    useEffect(() => {
        clearAlertes();
        dispatch(
            getAPI(
                usagerClientReducer,
                `${API_GET_EMPLOYES_LISTE_METIER_ASSO}/${id}`,
                CONTEXT_GET_EMPLOYES_LISTE,
            ),
        );
    }, []);

    useEffect(() => {
        if (dataEmploye) {
            const { nom, prenomUn, prenomDeux, prenomTrois, prenomQuatre, email, actif } =
                dataEmploye;
            reset({
                nom,
                prenomUn,
                prenomDeux,
                prenomTrois,
                prenomQuatre,
                email,
                actif: actif?.toString(),
            });
        }
    }, [dataEmploye]);

    return (
        <SegmentLoader
            isLoading={
                isLoadingEmploye || isLoadingModifierEmploye || isLoadingReinitialiserMotDePasse
            }
        >
            <h1>Modifier un employé</h1>

            <ButtonLink
                as={Link}
                name="ModifierEmploye"
                to={getPath(RoutesMonCompte.subroutes.listeEmployes)}
                variant="secondary"
                icon="fr-fi-arrow-left-line"
                iconPosition="left"
            >
                Liste des employés
            </ButtonLink>

            <div className="employeManagement-marginTop">
                <FormProvider {...hookForm}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <EmployeForm update />
                        <Row className="margin-top-lg">
                            <Col>
                                <ButtonGroup inline align="left">
                                    <Button
                                        onClick={handleReinitialiserMotDePasse}
                                        name="reinitialiserMotDePasse"
                                        variant="primary"
                                        type="button"
                                    >
                                        Réinitialiser mot de passe
                                    </Button>
                                </ButtonGroup>
                            </Col>
                            <Col>
                                <ButtonGroup inline align="right">
                                    <Link
                                        to={getPath(RoutesListeEmployes)}
                                        style={{ backgroundImage: 'none' }}
                                    >
                                        <Button
                                            name="etapePrecedente"
                                            variant="secondary"
                                            type="button"
                                        >
                                            Annuler
                                        </Button>
                                    </Link>
                                    <Button
                                        name="etapeSuivante"
                                        variant="primary"
                                        type="submit"
                                        disabled={disableButton()}
                                    >
                                        Valider
                                    </Button>
                                </ButtonGroup>
                            </Col>
                        </Row>
                    </form>
                </FormProvider>
            </div>
        </SegmentLoader>
    );
};

ModifierEmploye.propTypes = {
    dataEmploye: PropTypes.array,
    isLoadingEmploye: PropTypes.bool,
    isLoadingModifierEmploye: PropTypes.bool,
    isLoadingReinitialiserMotDePasse: PropTypes.bool,
    errorModifierEmploye: PropTypes.bool,
    dataModifierEmploye: PropTypes.object,
    clearAlertes: PropTypes.func.isRequired,
};

export default connect(
    (state) => {
        const {
            isLoading: isLoadingModifierEmploye,
            data: dataModifierEmploye,
            error: errorModifierEmploye,
        } = state.gestionEmployes?.modifierEmploye || {};

        const { data: dataEmploye, isLoading: isLoadingEmploye } =
            state.gestionEmployes.employesManagementStore;

        const { isLoading: isLoadingReinitialiserMotDePasse } =
            state.gestionEmployes.reinitialiserMotDePasseEmploye;

        return {
            dataEmploye,
            isLoadingEmploye,
            isLoadingModifierEmploye,
            isLoadingReinitialiserMotDePasse,
            errorModifierEmploye,
            dataModifierEmploye,
        };
    },
    {
        postApi: postAPI,
        clearAlertes: hideAllNotification,
    },
)(ModifierEmploye);
